import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axios from "axios";
import { toast } from "react-toastify";

const initialState = {
	list: [],
	documentHistory: null,
	total: 0,
	document: null,
	error: "",
	loading: false,
};

// ADD_document
export const addDocument = createAsyncThunk(
	"document/addDocument",
	async (values, { rejectWithValue }) => {
	  try {
		console.log("slice values", values);
		const { data } = await axios({
		  method: "post",
		  headers: {
			Accept: "application/json",
			"Content-Type": "multipart/form-data",
		  },
		  url: `document-form/uploadDocument`,
		  data: {
			...values,
		  },
		});
		console.log("data", data);
		toast.success("Document created successfully!");
		return {
		  data,
		  message: "success",
		};
	  } catch (error) {
		console.log("Error response:", error.response);
  
		// Handle server-side validation errors
		if (error.response && error.response.data && error.response.data.message) {
		  toast.error(error.response.data.message); // Display the server-side error message
		} else {
		  toast.error("Error in creating document, try again!");
		}
  
		return rejectWithValue({
		  message: error.response?.data?.message || "Unknown error occurred",
		});
	  }
	}
  );
  

// Approve_document
export const updatedocumentForm = createAsyncThunk(
	"document/updatedocumentForm",
	async ({ id, values }) => {
		try {
			const { data } = await axios({
				method: "put",
				headers: {
					Accept: "application/json",
					"Content-Type": "multipart/form-data",
				},
				url: `document-form/${id}`,
				data: {
					...values,
				},
			});

			toast.success(" document Approved");
			return {
				data,
				message: "success",
			};
		} catch (error) {
			toast.error("Error in approving try again");
			console.log(error.message);
		}
	}
);

// document_DETAILS
export const getDocumentsByUserId = createAsyncThunk(
	"document/getDocumentsByUserId",
	async (userId) => {
		try {
			const data = await axios.get(`document-form/getDocumentsByUserId/${userId}`);
			return data;
		} catch (error) {
			console.log(error.message);
		}
	}
);

// get document by status and pagination
export const loaddocumentFormByStatus = createAsyncThunk(
	"document/loaddocumentFormByStatus",
	async ({ status, page, limit }) => {
		try {
			const { data } = await axios.get(
				`document-form?page=${page}&count=${limit}&status=${status}`
			);
			return data;
		} catch (error) {
			console.log(error.message);
		}
	}
);

// documents
export const loadAlldocumentForm = createAsyncThunk(
	"document/loadAlldocumentForm",
	async () => {
		try {
			const { data } = await axios.get(`document-form?query=all`);

			return data;
		} catch (error) {
			console.log(error.message);
		}
	}
);

// count document forms
export const countdocumentForm = createAsyncThunk(
	"document/countdocumentForm",
	async () => {
		try {
			const { data } = await axios.get(`document-form`);
			return data;
		} catch (error) {
			console.log(error.message);
		}
	}
);

// get Single document history
export const loadSingledocumentHistory = createAsyncThunk(
	"document/loadSingledocumentHistory",
	async (id) => {
		// console.log("gettinIDfromComponent", id);
		try {
			const { data } = await axios.get(`document-form/document-history/${id}/`);
			// console.log("dataFromAPI: ", data);
			return data;
		} catch (error) {
			console.log(error.message);
		}
	}
);


const documentFormSlice = createSlice({
	name: "documentForm",
	initialState,
	reducers: {
		clearDocumentForm: (state) => {
			state.document = null;
		},
	},
	extraReducers: (builder) => {
		// 1) ====== builders for loadAlldocumentForm ======

		builder.addCase(loadAlldocumentForm.pending, (state) => {
			state.loading = true;
		});

		builder.addCase(loadAlldocumentForm.fulfilled, (state, action) => {
			state.loading = false;
			state.documentHistory = action.payload;
		});

		builder.addCase(loadAlldocumentForm.rejected, (state, action) => {
			state.loading = false;
			state.error = action.payload.message;
		});

		builder.addCase(addDocument.pending, (state) => {
			state.loading = true;
		});

		builder.addCase(addDocument.fulfilled, (state, action) => {
			state.loading = false;
		});

		builder.addCase(addDocument.rejected, (state, action) => {
			state.loading = false;
			state.error = action.payload.message;
		});

		// 3) ====== builders for getDocumentsByUserId ======

		builder.addCase(getDocumentsByUserId.pending, (state) => {
			state.loading = true;
		});

		builder.addCase(getDocumentsByUserId.fulfilled, (state, action) => {
			state.loading = false;
			state.document = action.payload.data;
		});

		builder.addCase(getDocumentsByUserId.rejected, (state, action) => {
			state.loading = false;
			state.error = action.payload.message;
		});

		// 4) ====== builders for loaddocumentFormByStatus ======

		builder.addCase(loaddocumentFormByStatus.pending, (state) => {
			state.loading = true;
		});

		builder.addCase(loaddocumentFormByStatus.fulfilled, (state, action) => {
			state.loading = false;
			state.list = action.payload;
		});

		builder.addCase(loaddocumentFormByStatus.rejected, (state, action) => {
			state.loading = false;
			state.error = action.payload.message;
		});

		// 3) ====== builders for updatedocumentForm ======

		builder.addCase(updatedocumentForm.pending, (state) => {
			state.loading = true;
		});

		builder.addCase(updatedocumentForm.fulfilled, (state, action) => {
			state.loading = false;
			const list = [...state.list];
			const index = list.findIndex(
				(document) => document.id === parseInt(action.payload.data.id)
			);
			list[index] = action.payload.data;
			state.list = list;
		});

		builder.addCase(updatedocumentForm.rejected, (state, action) => {
			state.loading = false;
			state.error = action.payload.message;
		});

		

		// 5) ====== builders for countdocumentForm ======

		builder.addCase(countdocumentForm.pending, (state) => {
			state.loading = true;
		});

		builder.addCase(countdocumentForm.fulfilled, (state, action) => {
			state.loading = false;
			const length = action.payload.length;
			state.total = length;
		});

		builder.addCase(countdocumentForm.rejected, (state, action) => {
			state.loading = false;
			state.error = action.payload.message;
		});

		// 6) ====== builders for loadSingledocumentHistory ======

		builder.addCase(loadSingledocumentHistory.pending, (state) => {
			state.loading = true;
		});

		builder.addCase(loadSingledocumentHistory.fulfilled, (state, action) => {
			console.log(action.payload);
			state.loading = false;
			state.documentHistory = action.payload;
		});

		builder.addCase(loadSingledocumentHistory.rejected, (state, action) => {
			state.loading = false;
			state.error = action.payload.message;
		});
	},
});

export default documentFormSlice.reducer;
export const { clearDocumentForm } = documentFormSlice.actions;
